<template>
  <el-container class="page_layout_container" v-responsive-layout
                :class="{page_gray: setting.cms_page_gray === 1}"
                :style="topColumnDrawerStyle">
    <el-header height="60px" class="head_area">
      <div class="header_layout_container">
        <div class="logo_area">
          <template v-if="isNotEmpty(setting.cms_logo)">
            <el-image :src="getFileUrl(setting.cms_logo)" class="logo_image"
                      @click="handleClickLogo">
              <template #error>
                <div class="image-slot">
                  <img src="@assets/logo.png" alt="" class="err_icon">
                </div>
              </template>
            </el-image>
          </template>
          <div class="website_name" v-if="isNotEmpty(setting.cms_website_name)"
               @click="handleClickLogo">{{ setting.cms_website_name || '' }}
          </div>
        </div>
        <div class="column_area">
          <div class="column_item" v-for="(item, index) in topColumnList" :key="index"
               :class="{ active: currColumn && currColumn.sid === item.sid }"
               @click="handleClickColumn(item)">
            <template v-if="isNotEmpty(item.icon_url)">
              <el-image :src="item.icon_path" class="column_icon" />
            </template>
            <div class="column_name">{{ item.name }}</div>
          </div>
          <template v-if="isLogined">
            <el-dropdown size="large" @command="handleDropdownCommand">
              <div class="column_item login_info">
                <template v-if="isNotEmpty(headPicUrl)">
                  <el-image :src="headPicUrl" class="column_icon" />
                </template>
                <div class="column_name">{{ userInfo.name }}</div>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="info">个人信息</el-dropdown-item>
                  <el-dropdown-item command="change_pwd" v-if="isNotEmpty(userInfo.login_id)">修改密码</el-dropdown-item>
                  <el-dropdown-item command="account_setting" v-else>设置账号</el-dropdown-item>
                  <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
          <template v-else>
            <div class="column_item" @click="handleOpenLogin">
              <div class="column_name">登录</div>
            </div>
          </template>
        </div>
        <div class="drawer_area">
          <template v-if="isLogined">
            <el-dropdown size="large" @command="handleDropdownCommand">
              <div class="column_item login_info">
                <template v-if="isNotEmpty(headPicUrl)">
                  <el-image :src="headPicUrl" class="column_icon" />
                </template>
                <div class="column_name">{{ userInfo.name }}</div>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="info">个人信息</el-dropdown-item>
                  <el-dropdown-item command="change_pwd" v-if="isNotEmpty(userInfo.login_id)">修改密码</el-dropdown-item>
                  <el-dropdown-item command="account_setting" v-else>设置账号</el-dropdown-item>
                  <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
          <template v-else>
            <div class="column_item" @click="handleOpenLogin">
              <div class="column_name">登录</div>
            </div>
          </template>
          <i class="fa fa-list" @click="showDrawer = true" />
        </div>
      </div>
    </el-header>
    <el-main class="content_layout_container">
      <router-view @event="handleRouterViewEvent" />
      <el-backtop target=".content_layout_container" :visibility-height="100" />
    </el-main>
    <template v-if="isNotEmpty(setting.cms_copyright)">
      <el-footer class="footer_area" height="30px">
        <span>{{ setting.cms_copyright }}</span>&nbsp;&nbsp;<span v-html="setting.beian_html"></span>
      </el-footer>
    </template>

    <el-drawer v-model="showDrawer" direction="rtl" custom-class="page_drawer"
               :with-header="false">
      <div class="drawer_column_area">
        <div class="column_item" v-for="(item, index) in topColumnList" :key="index"
             @click="handleClickColumn(item)">
          <template v-if="isNotEmpty(item.icon_url)">
            <el-image :src="item.icon_path" class="column_icon" />
          </template>
          <div class="column_name">{{ item.name }}</div>
        </div>
      </div>
    </el-drawer>

    <wx-login-dialog ref="wxLoginDialog" />
    <login-dialog ref="loginDialog" @event="handleDialogEvent" />
    <reg-user-dialog auto-login ref="regUserDialog" @event="handleDialogEvent" />
    <reg-user-info-dialog ref="regUserInfoDialog" />
    <change-password-dialog ref="changePasswordDialog" />
    <account-setting-dialog ref="accountSettingDialog" />
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent } from 'vue';
import wx from 'weixin-js-sdk';
import { loadJs } from '@/utils/loadResources';

export default {
  name: "PageLayout",
  components: {
    WxLoginDialog: defineAsyncComponent(() => import('@components/dialog/BindWxDialog')),
    LoginDialog: defineAsyncComponent(() => import('@components/dialog/LoginDialog')),
    RegUserDialog: defineAsyncComponent(() => import('@components/dialog/RegUserDialog')),
    RegUserInfoDialog: defineAsyncComponent(() => import('@components/dialog/RegUserInfoDialog')),
    ChangePasswordDialog: defineAsyncComponent(() => import('@components/dialog/ChangePasswordDialog')),
    AccountSettingDialog: defineAsyncComponent(() => import('@components/dialog/AccountSettingDialog')),
  },
  data() {
    return {
      columnList: [],
      showDrawer: false,
    };
  },
  computed: {
    ...mapState([ 'setting', 'currColumn', 'userInfo' ]),
    isLogined() {
      return this.userInfo && this.isNotEmpty(this.userInfo.sid);
    },
    addBdTongJi() {
      if (this.setting.cms_add_bdtongji === 1) {
        return this.isNotEmpty(this.setting.cms_bdtongji_code);
      }
      return false;
    },
    topColumnList() {
      return this.columnList.filter(item => item.location !== 'bottom');
    },
    topColumnDrawerStyle() {
      let length = 0;
      this.topColumnList.forEach(item => {
        if (item.name && item.name.length > length) {
          length = item.name.length;
        }
      });
      if (length > 0) {
        return {
          '--drawerWidth': `calc(${ length + 1 }em + 70px)`,
        };
      }
      return {};
    },
    headPicUrl() {
      if (this.isNotEmpty(this.userInfo.head_pic)) {
        let head_pic = this.userInfo.head_pic;
        if (this.isNotEmpty(head_pic) && head_pic.indexOf('http://') === -1
            && head_pic.indexOf('https://') === -1) {
          head_pic = this.getFileUrl(head_pic);
        }
        return head_pic;
      }
      return '';
    }
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async init() {
      await this.wechatLogin();
      await this.storeDispatch('initCmsSetting');
      if (this.addBdTongJi) {
        loadJs(`https://hm.baidu.com/hm.js?${ this.setting.cms_bdtongji_code }`);
      }
      await this.initColumnList();
      await this.getTagList();
    },
    async wechatLogin() {
      const _this = this;
      if (_this.isLogined && _this.isNotEmpty(_this.userInfo.open_id)) {
        return;
      }
      if (_this.$utils.isNotEmpty(window.configs.wx_login_code)) {
        let data = {
          access_code: window.configs.wx_login_code,
        };
        if (_this.isNotEmpty(_this.userInfo.sid)) {
          data.user_sid = _this.userInfo.sid;
        }
        let res = await _this.fetchData(_this.$api.API_GetOpenId, data).catch(err => err);
        if (res.code === 0) {
          let resData = res.data || {};
          if (resData.accessToken) {
            _this.storeCommit('SET_USER_INFO', resData);
            _this.storeCommit('SET_ACCESS_TOKEN', resData.accessToken);
          }
          window.configs.wx_login_code = undefined;
        }
      }
      if (_this.$utils.isNotEmpty(window.configs.xcx_login_code)) {
        let code = window.configs.xcx_login_code;
        let res = await _this.fetchData(_this.$api.API_LoginByXcx, { code }).catch(err => err);
        if (res.code === 0) {
          let resData = res.data || {};
          if (resData.accessToken) {
            _this.storeCommit('SET_USER_INFO', resData);
            _this.storeCommit('SET_ACCESS_TOKEN', resData.accessToken);
          }
          window.configs.xcx_login_code = undefined;
        }
      }
    },
    initColumnList() {
      let _this = this;
      return _this.fetchData(_this.$api.API_GetCmsColumnList).then(result => {
        _this.columnList = result.data || [];
        if (_this.isNotEmptyList(_this.columnList)) {
          _this.columnList.forEach(item => {
            if (_this.isNotEmpty(item.icon_url)) {
              item.icon_path = _this.getFileUrl(item.icon_url);
            }
          });
        }
        _this.storeCommit('SET_COLUMN_LIST', _this.columnList);
        if (_this.isNotEmpty(_this.currColumn.sid)) {
          let filter = _this.columnList.filter(item => item.sid === _this.currColumn.sid);
          if (_this.isNotEmptyList(filter)) {
            _this.storeCommit('SET_CURR_COLUMN', filter[0]);
          }
        } else {
          _this.storeCommit('SET_CURR_COLUMN', _this.columnList[0]);
        }
      }).catch(() => {
      });
    },
    getTagList() {
      let _this = this;
      return _this.fetchData(_this.$api.API_GetCmsTagList).then(result => {
        let resData = result.data || [];
        let tagList = [ { sid: '-1', name: '全部' } ].concat(resData);
        _this.storeCommit('SET_TAG_LIST', tagList);
      });
    },
    handleClickColumn(item) {
      this.showDrawer = false;
      this.storeCommit('SET_CURR_COLUMN', item);
      this.storeCommit('SET_ACTIVE_TAG', {});
      if (item.doc_num === 1) {
        if (this.isNotEmpty(item.ex_url)) {
          window.open(item.ex_url);
          return;
        }
        this.$router.push({
          path: `/detail/${ item.init_url }`,
        });
        return;
      }
      this.$router.push({
        path: `/page/${ item.code }`,
      });
    },
    handleDropdownCommand(command) {
      const _this = this;
      if (command === 'info') {
        if (this.$refs['regUserInfoDialog']) {
          this.$refs['regUserInfoDialog'].openDialog({});
        }
        return;
      }
      if (command === 'change_pwd') {
        if (this.$refs['changePasswordDialog']) {
          this.$refs['changePasswordDialog'].openDialog({});
        }
        return;
      }
      if (command === 'account_setting') {
        if (this.$refs['accountSettingDialog']) {
          this.$refs['accountSettingDialog'].openDialog({
            data: this.userInfo,
          });
        }
        return;
      }
      if (command === 'logout') {
        this.storeCommit('SET_USER_INFO', {});
        this.storeCommit('SET_ACCESS_TOKEN', {});
        let browserInfo = _this.$utils.getBrowserInfo();
        if (browserInfo.miniProgram) {
          let route = _this.$XEUtils.locat();
          wx.miniProgram.redirectTo({
            url: '/pages/index/index?op=logout&href=' + route.href,
          });
        }
      }
    },
    handleClickLogo() {
      this.$router.push('/');
    },
    handleOpenLogin() {
      const _this = this;
      // if (true) {
      //   // 模拟微信登录
      //   _this.simulateWxLogin();
      //   return;
      // }
      let browserInfo = _this.$utils.getBrowserInfo();
      if (browserInfo.miniProgram) {
        // 微信小程序web-view打开
        let route = _this.$XEUtils.locat();
        wx.miniProgram.redirectTo({
          url: '/pages/index/index?op=login&href=' + route.href,
        });
        return;
      }
      if (browserInfo.weixin) {
        // 微信浏览器打开
        _this.fetchData(_this.$api.API_GetOpenId).then(res => {
          let resData = res.data || {};
          let route = _this.$XEUtils.locat();
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + resData.app_id
              + '&redirect_uri=' + encodeURIComponent(route.href)
              + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
        }).catch(() => {
        });
        return;
      }
      if (_this.$refs['loginDialog']) {
        _this.$refs['loginDialog'].openDialog({});
      }
    },
    handleDialogEvent(event) {
      if (event.type === 'regUser') {
        if (this.$refs['regUserDialog']) {
          this.$refs['regUserDialog'].openDialog({});
        }
        return;
      }
      if (event.type === 'autoLogin') {
        if (this.$refs['loginDialog']) {
          this.$refs['loginDialog'].closeDialog();
        }
      }
    },
    handleRouterViewEvent(event) {
      if (event.type === 'login') {
        this.handleOpenLogin();
      }
    },
    simulateWxLogin() {
      let _this = this;
      return _this.fetchData(_this.$api.API_SimulateWxLogin, {
        open_id: 'o-x1Dt6MisHL0w8ovJPePHvFPRWE',
      }).then(result => {
        let token = result.data || '';
        if (_this.isNotEmpty(token)) {
          this.$router.push({
            path: '/autoLogin',
            query: { token },
          });
        }
      }).catch(() => {
      });
    },
  },
}
</script>

<style scoped src="./PageLayout.scss" lang="scss" />